import React from 'react'
import {Faq} from "../components/faq/Faq"
import Layout from '../Layout/Layout'


function faq()  {
    return (
        <div>
        <Layout>
            <Faq />
        </Layout>
        </div>
    )
}
export default faq;